export const ACCOUNT_PASSWORD_RESET = {
    TITLE: 'Forgot your Password?',
    DESCRIPTION:
        'Enter your username to reset your password. In most cases, your username is also your email address.',
    HELP_TEXT_HEADING: 'Having sign in trouble?',
    HELP_TEXTS: [
        'Spaces are not allowed in usernames or passwords.',
        'Your username is case sensitive and is most commonly your work email address.',
        'Check your spam folder if you do not receive an email within a few minutes after submitting your request.',
    ],
    RETURN_TO_LOGIN: 'Return to Sign in',
    SEND_RESET_LINK: 'Send Reset Link',
    HERE: 'here',
    RESET_YOUR_PASSWORD_1: 'reset your password',
    RESET_YOUR_PASSWORD_2: 'Reset your password',
    RESET_YOUR_PASS_LINK_1: '<a href="/auth/help-options">reset your password</a>',
    RESET_YOUR_PASS_LINK_2: '<a href="/auth/account-password-reset">Reset your password</a>',
};

export const PASSWORD_RESET_EMAIL_SENT = {
    TITLE: 'Check Your Email',
    DESCRIPTION: "We've sent an email with a link to finish resetting your password.",
    HELP_TEXT:
        "Can't find the email? Try checking your spam folder. If you still can't sign in, try resending the reset email or contact your HR administrator.",
    RETURN_TO_LOGIN: 'Return to Sign in',
};

export const FORGOT_USERNAME = {
    TITLE: 'Forgot what your Username is?',
    DESCRIPTION: 'We can help! Enter your email address.',
    FORGOT_EMAIL: 'CONTACT_SUPPORT for assistance.',
    CONTACT_SUPPORT: 'Contact Support',
    FIND_MY_USERNAME: 'Find My Username',
};

export const FORGOT_PASSWORD = {
    TITLE: 'Set Your Password',
    DESCRIPTION: 'Your password must have the following:',
    NOTE: 'Note: spaces are never allowed in your password',
    CONFIRM_PASSWORD: 'Confirm Password',
    FIND_MY_USERNAME: 'Find My Username',
};

export const FORGOT_PASSWORD_SUCCESS = {
    TITLE: 'Your Password Has Been Reset',
    DESCRIPTION_1: "We've sent an email confirming this change for your records.",
    DESCRIPTION_2: "Can't find the email? Try checking your spam folder.",
    DESCRIPTION_3:
        "If you still can't sign in, try resending the reset email or contact your HR administrator.",
    SIGN_IN: 'Return To Sign in',
};

export const FORGOT_PASSWORD_EXPIRED = {
    TITLE: 'Set Password Link Expired',
    DESCRIPTION:
        'The password set or reset link you clicked is no longer valid. If you still need to reset your password or find your username: Go to the FORGOT_PASSWORD_OR_USERNAME page.',
    RESET_PASSWORD: 'Reset My Password',
    SIGN_IN: 'Return To Sign in',
    FORGOT_PASSWORD_OR_USERNAME: 'Forgot Password / Forgot Username',
};

export const LOGIN_MODAL = {
    TITLE: 'Sign in Required',
    DESCRIPTION: 'To proceed any further, you must first sign in.',
    SIGN_IN_MODAL_DESCRIPTION:
        'This session has timed out. To protect your security and continue the session, please sign back in.',
};
